import classnames from 'classnames';

import { Snackbar, SnackbarSkins } from '@picsart/snackbar';
import IconInfoCircleOutline from '@picsart/icons/IconInfoCircleOutline';
import { Accents, FontWeights, Typography } from '@picsart/cascade';
import { Text } from '@picsart/text';
import useStyles from './useStyles';

function Error({ text, isBorder, cb }: { text: string; isBorder: boolean; cb: () => void }) {
  const classes = useStyles() as Record<string, string>;

  return (
    <Snackbar
      className={classnames(classes.wrapper, {
        [classes.snackbar]: isBorder,
      })}
      actionIcon={IconInfoCircleOutline}
      skin={SnackbarSkins.Error}
      handleClose={cb}
      isFullWidth
    >
      <Text size={Typography.t5} weight={FontWeights.SemiBold} color={Accents.primary.text.default}>
        {text}
      </Text>
    </Snackbar>
  );
}

export default Error;
